export default __webpack_public_path__ + "static/media/Slide24.407f675e.PNG";